<template>
  <label class="ui-search">
    <v-icon size="18">mdi-magnify</v-icon>
    <input ref="input" type="search" :value="value" :placeholder="placeholder" :aria-label="label || placeholder" @input="$emit('input', $event.target.value)" />
  </label>
</template>

<script>
/** Polje za pretragu sa lupom. v-model; focus() fokusira i označava tekst (prečica "/"). */
export default {
  name: "UiSearch",
  props: {
    value: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    label: { type: String, default: "" },
  },
  methods: {
    focus() {
      this.$refs.input.focus();
      this.$refs.input.select();
    },
  },
};
</script>
